var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"body"},[_c('iframe',{staticClass:"plugin",attrs:{"src":_vm.url}}),(!_vm.loaded)?_c('div',{staticClass:"loading"},[_c('p',[_vm._v("Loading plugin "+_vm._s(_vm.plugin.label)+" ...")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }